// Static values for the QRPH QR flow (button, generation, display, polling).

export const QRPH_DEFAULTS = {
  PROXY_TYPE: process.env.REACT_APP_QRPH_PROXY_TYPE || "",
  PROXY_VALUE: process.env.REACT_APP_QRPH_PROXY_VALUE || "",
  MERCHANT_NAME: "Merchant",
};

export const QRPH_REFERENCE = {
  SANITIZE_REGEX: /[^A-Za-z0-9]/g,
  MAX_LENGTH: 32,
};

export const QRPH_TIMER = {
  SCAN_SECONDS: parseInt(process.env.REACT_APP_QRPH_SCAN_SECONDS || "300"),
  STATUS_POLL_MS: parseInt(process.env.REACT_APP_QRPH_STATUS_POLL_MS || "3000"),
  URGENT_THRESHOLD_SECONDS: 10,
};

export const QRPH_TRANSACTION_STATUS = {
  SUCCESS: ["SUCCESSFUL", "SUCCESSFULL"],
  FAILURE: ["NOTSUCCESSFUL", "NOTSUCCESSFULL"],
};

export const QRPH_AMOUNT_POPUP = {
  LOGO: "/cards/php-amount.png",
  TYPE: "qrph",
};
